import { combineReducers } from "redux";
import { orgSelectorState } from "./orgSelectorReducer";

export const orgSelectorReducers = combineReducers({
    orgSelectorState: orgSelectorState
});
